var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"to":"/analytics"}},[_vm._v("Overview")]),_vm._v(" "),_c('v-tab',{attrs:{"to":"/analytics/invoices"}},[_vm._v("Invoices")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610415dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/analytics/AnalyticsPage.vue
// module id = null
// module chunks = 